import { Component } from "@angular/core";

@Component({
  selector: "app-vittaa-slider-mobile",
  templateUrl: "./vittaa-slider-mobile.component.html",
  styleUrls: ["./vittaa-slider-mobile.component.scss"],
})
export class VittaaSliderMobileComponent {
  slides = [
    { img: "assets/img/vittaa/01_vittaa.webp" },
    { img: "assets/img/vittaa/02_vittaa.webp" },
    { img: "assets/img/vittaa/03_vittaa.webp" },
    { img: "assets/img/vittaa/04_vittaa.webp" },
    { img: "assets/img/vittaa/05_vittaa.webp" },
    { img: "assets/img/vittaa/06_vittaa.webp" },
    { img: "assets/img/vittaa/07_vittaa.webp" },
    { img: "assets/img/vittaa/08_vittaa.webp" },
    { img: "assets/img/vittaa/09_vittaa.webp" },
    { img: "assets/img/vittaa/10_vittaa.webp" },
    { img: "assets/img/vittaa/11_vittaa.webp" },
    { img: "assets/img/vittaa/12_vittaa.webp" },
    { img: "assets/img/vittaa/13_vittaa.webp" },
    { img: "assets/img/vittaa/14_vittaa.webp" },
    { img: "assets/img/vittaa/15_vittaa.webp" },
    { img: "assets/img/vittaa/16_vittaa.webp" },
    { img: "assets/img/vittaa/17_vittaa.webp" },
    { img: "assets/img/vittaa/18_vittaa.webp" },
    { img: "assets/img/vittaa/19_vittaa.webp" },
  ];

  breakpoints = [
    {
      breakpoint: 9999,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ];

  slideConfig = {
    dots: true,
    responsive: this.breakpoints,
  };

  slickInit(e) {
    console.log("slick initialized");
  }

  breakpoint(e) {
    console.log("breakpoint");
  }

  afterChange(e) {
    console.log("afterChange");
  }

  beforeChange(e) {
    console.log("beforeChange");
  }

  constructor() {}

  ngOnInit() {}
}
